// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3LlKX","controls":"styles_controls__1Y9mh","charLimit":"styles_charLimit__2UJRh","input":"styles_input__3TUIX","send":"styles_send__fzm7T"};